export default function calculateWrapOutside(
    offsetX: number,
    width: number,
    parentWidth: number
): { x: number; outOfBounds: number | null } {

    const halfWidth = width / 2;
    const x = (parentWidth / 2) + offsetX - halfWidth;

    const outOfBounds =
        x < 0
            ? x - width
            : x + width > parentWidth
                ? x  - parentWidth
                : null;

    return { x, outOfBounds };
}